import React from "react";
import styles from "./CTASection.module.scss";
import { Button2, SnapSection, bounceIn } from "../../components";
import { motion } from "motion/react";
import FeaturedVideo from "../FeaturedVideo";


function CTASection(props) {
  return (
    <SnapSection light>
        <motion.div className={`${props.className} ${styles.getStarted}`} {...bounceIn}>
            <div className={styles.getStartedContent}>
            {props.title && (<h1>{props.title}</h1>)}
            {props.subtitle && (<p>{props.subtitle}</p>)}
            </div>
            <div className={styles.actions}>
            {props.secondaryVideo && (
              <FeaturedVideo className={styles.actionButton} video={props.secondaryVideo}>
                <Button2 dark outline className={styles.actionButton}>{props.secondaryButtonLabel}</Button2>
              </FeaturedVideo>
            )}
            {props.secondaryButton && (<Button2 to={props.secondaryButton} outline dark className={styles.actionButton}>{props.secondaryButtonLabel}</Button2>)}
            {props.primaryButton && (<Button2 to={props.primaryButton} dark className={styles.actionButton}>{props.primaryButtonLabel}</Button2>)}
            </div>
        </motion.div>
    </SnapSection>
  );
}

export default CTASection;